import { StepProps } from './Step';
import React from 'react';
import { Stack } from '@ardoq/layout';

/**
 * @param child: React.ReactElement<StepProps> is a child of type Step, we will add a number to it
 * if it doesn't have an icon or custom number
 * @returns wrapped child with number if it doesn't have an icon or custom number
 */

function AddStepProps({
  child,
  index = 0,
  isLast,
}: {
  child: React.ReactElement<StepProps>;
  isLast: boolean;
  index?: number;
}) {
  const strikeThroughLocation =
    index === 0 ? 'bottom' : isLast && !child.props.expanded ? 'top' : 'both';
  const stepNumber = child.props.stepNumber || index + 1;
  const orientation = 'vertical';
  return React.cloneElement(child, {
    stepNumber,
    orientation,
    strikeThroughLocation,
    isLast,
  });
}

type VerticalStepperProps = {
  children: React.ReactElement<StepProps> | React.ReactElement<StepProps>[];
};

export function VerticalStepper({ children }: VerticalStepperProps) {
  return (
    <Stack>
      {Array.isArray(children) ? (
        children.map((child, index) => (
          <AddStepProps
            isLast={children.length - 1 === index}
            key={index}
            child={child}
            index={index}
          />
        ))
      ) : (
        <AddStepProps isLast={true} child={children} />
      )}
    </Stack>
  );
}
